"use client";

import { useEffect } from "react";

// Fades in every [data-reveal] element inside the page as it scrolls into view.
// Content is fully visible without JavaScript; the hidden state only applies once this runs.
export default function RevealOnScroll({ rootId }) {
  useEffect(() => {
    const root = document.getElementById(rootId);
    if (!root) return;

    const items = root.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window)) return;

    root.setAttribute("data-js", "");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-in", "");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    items.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [rootId]);

  return null;
}
